<template>
  <div>
    <vue-snotify></vue-snotify>
    <builderall-appshell v-if="!notShowWrapper.includes(this.$route.name)" :token="getOfficeToken()"
      tool="website-builder" class="builderall-css">
      <div id="app" class="ba-app-content">
        <img src="/static/images/liquid-bg.png" alt="SiteBuilder BG El" class="sitebuilder-bg-el">
        <div class="sitebuilder-banner">
          <div>
            <h1>Builderall Website Builder</h1>
            <p>{{ $t('ct-banner-description') }}</p>
          </div>
          <div class="ba-grid ba-gp-1 ba-ai-center top-actions-dashboard">
            <search-input
              v-if="showWebsiteSearch"
              class="sitebuilder-search-input ba-h-100"
              :config="websiteSearchConfig"
              @search="onWebsiteSearch"
            />
            <div v-else />
            <router-link
              v-if="$route.name !== 'CreateWebsite'"
              data-ba-i="create-website"
              :to="{ name: 'CreateWebsite', query: { step: 'template' } }"
              class="ba-btn ba-md ba-blue"
            >
              <builderall-icon code='2780'></builderall-icon>
              {{ $t('ct-create-website') }}
              <span class='ba-badge ba-bg-green'>{{ $t('ct-now-with-ia')}}</span>
            </router-link>
            <button
              v-if="$route.name !== 'CreateWebsite'"
              type="button"
              data-ba-i="ai-html-upload"
              class="ba-btn ba-md ai-html-upload-btn"
              @click="openAiHtmlUpload"
            >
              <img height="22" style="filter: brightness(0) invert(1);" src="/static/images/icons/ai-html.svg" alt="Create Website">
               {{ $t('ct-ai-html-upload') }}
               <span class='ba-badge ba-bg-green'>{{ $t('ct-now-with-ia-editor')}}</span>
            </button>
          </div>
        </div>

        <ai-html-upload-popup ref="aiHtmlUploadPopup" @success="onAiHtmlUploadSuccess" />

        <div class="ba-app-wrapper ba-gp-1">
          <Sidebar />

          <router-view />
          <div></div>

          <digital-file-repository
            ref="digitalFileRepository"
            :show="showDigitalFileRepository"
            :accept="accept"
            :step="step"
            :saveFile="saveFile"
            :closeFile="closeFile"
            :textToUpload="textToUpload"
            :multiple="multiple"
            class="digital-file-repository"
          ></digital-file-repository>

          <div class='ba-footer'>
            <builderall-footer></builderall-footer>
          </div>
        </div>
      </div>
      <builderall-ai-agent-quick-actions
          :actions="aiAgentQuickActions">
      </builderall-ai-agent-quick-actions>
    </builderall-appshell>
    <div v-else id="app">
      <router-view />
      <div class="modal-loading-overlay">
        <div class="loader-spinna"></div>
      </div>
      <digital-file-repository
          ref="digitalFileRepository"
          :show="showDigitalFileRepository"
          :accept="accept"
          :step="step"
          :saveFile="saveFile"
          :closeFile="closeFile"
          :textToUpload="textToUpload"
          :multiple="multiple"
          class="digital-file-repository"
        ></digital-file-repository>
    </div>
  </div>
</template>

<script>
import { getUser } from './js/services/user';
import ModalFiles from './components/general/FilesManager/FileManager';
import Sidebar from './components/general/Sidebar.vue';
import DigitalFileRepository from './components/general/FilesManager/DigitalFileRepository';
import SearchInput from './components/general/SearchInput.vue';
import AiHtmlUploadPopup from './components/dashboard/components/AiHtmlUploadPopup.vue';
import {mapGetters} from "vuex";

export default {
  name: 'App',
  components: {
    ModalFiles,
    Sidebar,
    DigitalFileRepository,
    SearchInput,
    AiHtmlUploadPopup,
  },
  data() {
    return {
      hasDashboardWebsites: false,
      websiteSearchConfig: { search: '' },
      title: 'Website Builder',
      accept: 'Videos',
      multiple: false,
      step: '',
      textToUpload: '',
      showDigitalFileRepository: false,
      saveFile: () => {},
      closeFile: () => {},
      notShowWrapper: ['editor', 'AiEditor', 'editor-layout-item', 'editor-default-item', 'Redirector', 'RedirectElearning', 'CheetahRedirectorPage', 'Login', 'PublicLinkSave', 'TemplatePreview', 'AiResources', 'supercheckout-bridge']
    };
  },
  computed: {
    showWebsiteSearch() {
      return (
        (this.$route.name === 'Dashboard' || this.$route.name === 'Home') &&
        this.hasDashboardWebsites
      );
    },
    aiAgentQuickActions() {
      return JSON.stringify([
        { label: this.$t('ct-create-site'), slug: 'create_website' }
      ]);
    },
  },
  watch: {
    $route: function (current, old) {
      try {
        this.addOrRemoveBuilderallCss();
        this.toggleIntercomVisibility();
      } catch (e) {
        console.error(e);
      }

      if (current.name !== 'Dashboard' && current.name !== 'Home') {
        this.hasDashboardWebsites = false;
      }
    },
  },
  methods: {
    ...mapGetters({ getOfficeToken: 'getOfficeToken' }),
    onWebsiteSearch() {
      this.$root.$emit('dashboard-website-search', this.websiteSearchConfig.search);
    },
    onDashboardHasWebsites(hasWebsites) {
      this.hasDashboardWebsites = hasWebsites;
    },
    openAiHtmlUpload() {
      this.$refs.aiHtmlUploadPopup.open();
    },
    onAiHtmlUploadSuccess({ website, isCreation } = {}) {
      // New uploads open the editor. Replacing HTML on an existing site stays on the list.
      if (isCreation && website && website.encrypted_id) {
        this.$router.push({
          name: 'AiEditor',
          params: { id: website.encrypted_id },
          query: { fromImport: '1' },
        });
        return;
      }

      this.$root.$emit('dashboard-refresh-websites');
    },
    addOrRemoveBuilderallCss() {
      const lib = {
        io: 'https://css.kub.app.builderall.io/builderall.css',
        info: 'https://css.kub.app.builderall.info/builderall.css',
        com: 'https://css.builderall.com/builderall.css'
      };
      const env = window.location.host.includes('.com') ? 'com' : (window.location.host.includes('.info') ? 'info' : 'io');
      const urlStyle = lib[env];
      const linkRel = document.getElementById('link-builderall-css');
      if (!this.notShowWrapper.includes(this.$route.name) || this.$route.name == 'supercheckout-bridge') {
        if (linkRel) return;

        // Adiciona css style
        var link = document.createElement('link');
        link.rel = "stylesheet";
        link.id = "link-builderall-css";
        link.type = "text/css";
        link.href = urlStyle;
        document.head.appendChild(link);

      } else if (linkRel) {
        // remove style css
        linkRel.remove();
      }
    },
    // O launcher da Intercom é injetado pelo appshell direto no body, entao continua
    // no DOM mesmo nas rotas em que o <builderall-appshell> nao é renderizado.
    toggleIntercomVisibility() {
      const hide = this.notShowWrapper.includes(this.$route.name);
      document.body.classList.toggle('ba-hide-intercom', hide);
    },
    getLangFormat() {
      let languagesValid = ['ar-ar', 'da-da', 'de-de', 'el-el', 'en-us', 'es-es', 'fa-fa',
        'fr-fr', 'he-il', 'hi-hi', 'hu-hu', 'it-it', 'ja-jp', 'pl-pl',
        'pt-br', 'ro-ro', 'ru-ru', 'si-si', 'sk-sk', 'th-th', 'tr-tr', 'vi-vi', 'zh-cn'
      ];

      let acceptLang = this.$lang.toLowerCase();

      if (languagesValid.includes(acceptLang)) {
        acceptLang = acceptLang.split('-');
        acceptLang[1] = acceptLang[1].toUpperCase();
        acceptLang = acceptLang.join('_');

        window.setCookie('languageEditorUser', acceptLang);

        return acceptLang;
      }
    }
  },
  created() {
    var vm = this;

    if (this.$route.query.search) {
      this.websiteSearchConfig.search = this.$route.query.search;
    }

    this.$root.$on('fileMananger', async (values) => {
      this.accept       = values.type;
      this.saveFile     = values.save;
      this.closeFile    = values.close;
      this.step         = values.step;
      this.textToUpload = values.textToUpload;
      this.multiple     = values.multiple || false;

      if (values.action == 'open') {
        try {
          await this.$store.dispatch('ensureOfficeToken');
          this.showDigitalFileRepository = true;
        } catch (e) {
          console.error('Unable to ensure office token for file repository', e);
          this.showDigitalFileRepository = false;
          this.$snotify.error(this.$t('ct-error-message'));
        }
      } else {
        this.showDigitalFileRepository = false;
      }
    });

    var login = !!(
      localStorage.getItem('login') && localStorage.getItem('login') === 'true'
    );

    if (login) {
      getUser(this.getOfficeToken())
        .then(({ data }) => {
          if (data.success) {
            let user = data.user;

            this.$translate.seti18n(this.$i18n);
            this.$translate.setLang(user.lang ? user.lang : this.getLangFormat());
            this.$translate.init(user.lang ? user.lang : this.getLangFormat());
            this.$store.commit('user', user);

            window.setCookie('email', user.email);
          }
        })
    }

    this.$root.$on('linkAction', (link) => {
      switch (link.type) {
        case 'web': {
          if (link.value !== '') {
            if (link.target === '_blank') {
              window.open(link.value, '_blank');
            } else {
              window.location.href = link.value;
            }
          }
          break;
        }
        case 'page': {
          pagesConfig.forEach(page => {
            if (link.valueID == page.id) {
              if (link.target === '_blank') {
                window.open('/' + page.url, '_blank');
              } else {
                window.location.href = '/' + page.url;
              }
            }
          });
          break;
        }
        case 'anchor': {
          let pageAnchor = {};
          let anchorName = '';
          pagesConfig.forEach(page => {
            if (typeof page !== 'undefined' && typeof page.configs !== 'undefined') {
              page.configs.forEach(config => {
                if (config.key === 'anchors') {
                  let anchors = JSON.parse(config.value);
                  if (typeof anchors[link.valueID] !== 'undefined') {
                    pageAnchor = page;
                    anchorName = anchors[link.valueID];
                  }
                }
              });
            }
          });
          if (anchorName !== '') { window.location.href = '/' + pageAnchor.url + '#' + anchorName }
          break;
        }
        case 'popup': {
          let vm = this;

          this.userPopups.forEach(popup => {
            if (link.valueID == popup.id) {
              vm.$refs['popup' + popup.id][0].open();
            }
          });
          break;
        }
        case 'video': {
          if (link.value !== '') {
            this.$refs.videoModalIframe.src = link.value;
            this.$refs.videoModalIframeMobile.src = link.value;
            this.$refs.videoModal.open();
          }
          break;
        }

        case 'download': {
          let url = 'https://www.omb11.com/files/downloads';
          window.open(url + '?file_src=' + link.src + '&file_name=' + link.name + '&request=download', '_self');
        }

        case 'telefone': {
          window.open('tel:' + link.tel, '_blank');
          break;
        }
      }
    });
    this.addOrRemoveBuilderallCss();
    this.toggleIntercomVisibility();
    this.$root.$on('dashboard-has-websites', this.onDashboardHasWebsites);
  },
  beforeDestroy() {
    this.$root.$off('dashboard-has-websites', this.onDashboardHasWebsites);
  },
};
</script>

<style lang="scss">
@import "./assets/sass/_all.scss";
@import "./assets/lib/ba-css/ba-css-custom.scss";

#app {
  -webkit-font-smoothing: antialiased; // faz com que as fontes ficam igual em todos navegadores mac x janelas
  -moz-osx-font-smoothing: grayscale;
  background: #E9EDF2;
  height: auto;

  &.ba-app-content {
    position: absolute;
    width: calc(100% - 54px);
    height: calc(100% - 80px);
    background: linear-gradient(153.12deg, #EBF8EB 5.59%, #C7E3F6 83.26%);
    overflow-x: hidden;
    overflow-y: auto;

    .sitebuilder-bg-el {
      position: absolute;
      top: -70px;
      right: 0;
      width: auto;
      max-width: 500px;
      height: auto;
      pointer-events: none;
      user-select: none;
      z-index: 0;
    }
  }
}

body.ba-hide-intercom {
  #custom-intercom-launcher,
  #intercom-container,
  #intercom-frame,
  .intercom-lightweight-app,
  .intercom-namespace {
    display: none !important;
  }
}

.top-actions-dashboard {
  grid-template-columns: 1fr 1fr 1fr;
}

.sitebuilder-banner {
  position: relative;
  z-index: 1;
  background: transparent;
  padding: 48px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.sitebuilder-banner h1 {
  font-size: 32px;
  font-weight: 600;
  margin: 0;
  color: #3D3D3D;
}

.sitebuilder-banner p {
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  color: #4D5D71;
}

.ba-app-wrapper {
  position: relative;
  z-index: 1;
  margin-top: 0 !important;
}

.navbar {
  box-shadow: 0px 1px 2px #26242424;
  border: 1px solid #DEDEDE;
  opacity: 1;
}

.shadow {
  box-shadow: 0 0 2rem 0 #8898aa26 !important;
}

.btn-edit {
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  color: #F8FAFD;
  min-width: 127px;
  background: #04E2B0;
  box-shadow: 0.62px 0.79px 2px #1E120D1A;
  border-radius: 5px;
  opacity: 1;
  padding: 15px 15px;
}

.digital-file-repository{
  z-index: 99999;
  position: relative;
}

.btn-primary-light {
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  color: #0294FF;
}

.sitebuilder-search-input {
  background-color: #fff !important;
  outline: none !important;
  border: none !important;
}

.ba-btn:has(.ba-badge) {
  position: relative;

  .ba-badge {
    position: absolute;
    top: -14px;
    right: 0px;
    background: #01D47B;
    font-size: 10px;
    letter-spacing: 0%;
  }
}

.ai-html-upload-btn {
  background: #7E1AFD !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue